<!-- commented due to new design -->
<!-- comment start-->
<!--
<div class="row justify-content-center allergy-card">
  <div class="col-12">
    <fieldset class="mb-3 pb-0" [ngStyle]="{'display' : intakeFieldsSetting.isSocialHistoryAllowed ? '' : 'none'}">
      <legend class="lead">{{'social_history.social_history'|translate}}</legend>
      <div class="row">
        <div class="form-group col-sm-12 col-md-4 col-lg-4 tobaccoDD" [ngStyle]="{'display' : intakeFieldsSetting.IsTobaccoAllowed ? '' : 'none'}">
          <div class="form-select form-floating">
            <select name="ctl00$main$tobaccostatus" id="main_tobaccostatus" class="form-control"
                    [(ngModel)]="selected_objPatientSocialHistory.tobaccoStatusCode">
              <option selected="selected" value="" disabled>{{'social_history.social_history_tobacco_status'|translate}}</option>
              <option *ngFor="let tobaccoStatus of tobaccoStatusDropdownList"
                      [value]="tobaccoStatus.value">
                {{getTranslatedTextTobaccoStatus(tobaccoStatus.text)}}
              </option>
            </select>
            <label>{{'social_history.social_history_tobacco_status'|translate}}</label>
          </div>
        </div>-->
<!-- comment end-->
<!--<div class="form-group col-6 col-sm-6 col-md-4 col-lg-4 tobaccoEffectiveFromDiv" [ngStyle]="{'display' : intakeFieldsSetting.IsTobaccoFromAllowed ? '' : 'none'}">
    <div class="form-floating">
        <input class="form-control" type="date" max="{{curDate | date:'yyyy-MM-dd'}}" [(ngModel)]="selected_objPatientSocialHistory.tobaccoStartDate" name="tobaccoStartDate" (change)="onTobaccoDateChange()" />
        <label >Effective from</label>
    </div>
</div>
<div class="form-group col-6 col-sm-6 col-md-4 col-lg-4 tobaccoEffectiveToDiv" [ngStyle]="{'display' : intakeFieldsSetting.IsTobaccoToAllowed ? '' : 'none'}">
    <div class="form-floating">
        <input class="form-control" type="date" max="{{curDate | date:'yyyy-MM-dd'}}" [(ngModel)]="selected_objPatientSocialHistory.tobaccoEndDate" name="tobaccoEndDate" (change)="onTobaccoDateChange()" />
        <label>Effective to</label>
    </div>
</div>
<div class="form-group col-sm-12 tobaccoEffectiveToDiv" *ngIf="tobaccoDateError">
    <p class="err">{{tobaccoDateError}}</p>
</div>-->
<!-- comment start-->
<!--
        <div class="form-group col-sm-6 col-md-4  alcoholUsageDiv" [ngStyle]="{'display' : intakeFieldsSetting.IsAlcoholUsagePerDayAllowed ? '' : 'none'}">

          <div class="form-select form-floating">
            <select name="ctl00$main$alcohol" id="main_alcohol" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.alcoholDay">
              <option selected="selected" value="" disabled>{{'social_history.social_history_alcohol_usage'|translate}}</option>
              <option *ngFor="let alcoholUsageDay of alcoholUsageDayDropdownList" [value]="alcoholUsageDay.value">
                {{getTranslatedTextAlcoholUsage(alcoholUsageDay.text)}}
              </option>
            </select>
            <label>{{'social_history.social_history_alcohol_usage'|translate}}</label>
          </div>
        </div> -->
<!-- comment end-->
<!--<div class="form-group col-sm-6 col-md-4" [ngStyle]="{'display' : intakeFieldsSetting.IsNotesAllowed ? '' : 'none'}">
    <div class="form-floating">
        <input class="form-control" placeholder="How Long Using Tobacco?" id="duration" tabindex="17" type="text" [(ngModel)]="selected_objPatientSocialHistory.notes" name="notes">
        <label>Duration</label>
    </div>
</div>-->
<!-- comment start-->
<!--
      </div>
    </fieldset>
    <fieldset class="my-3 pb-0" [ngStyle]="{'display' : intakeFieldsSetting.isRistAssesmentAllowed ? '' : 'none'}">
      <legend class="lead">{{'social_history.social_history_risk_assessment'|translate}}</legend>
      <div class="row"> -->
<!-- comment end-->
<!--<div class="form-group col-sm-6 col-md-4 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsExerciseAllowed ? '' : 'none'}">
    <div class="form-select form-floating">
        <select name="ctl00$main$exercise" id="main_exercise" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.exercise">
            <option selected="selected" value="" disabled>Select Exercise</option>
            <option *ngFor="let exercise of exerciseDropdownList" [value]="exercise.value">{{exercise.text}}</option>
        </select>
        <label>Exercise</label>
    </div>
</div>-->
<!-- comment start-->
<!--
<div class="form-group col-sm-6 col-md-4 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsDrugUseAllowed ? '' : 'none'}">
  <div class="form-select form-floating">
    <select name="ctl00$main$drug" id="main_drug" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.drugUse">
      <option selected="selected" value="" disabled>{{'social_history.social_history_drug_usage'|translate}}</option>
      <option *ngFor="let drugUse of drugUseDropdownList" [value]="drugUse.value">{{getTranslatedTextDrugUsage(drugUse.text)}}</option>
    </select>
    <label>{{'social_history.social_history_drug_usage'|translate}}</label>
  </div>
</div>-->
<!-- comment end-->
<!--<div class="form-group col-sm-6 col-md-4 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsSeatbeltAllowed ? '' : 'none'}">
    <div class="form-select form-floating">
        <select name="ctl00$main$Seatbelt" id="main_Seatbelt" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.seatbelts">
            <option selected="selected" value="" disabled>Select Seatbelts</option>
            <option *ngFor="let seatBelt of seatbeltDropdownList" [value]="seatBelt.value">{{seatBelt.text}}</option>
        </select>
        <label>Seat Belt</label>
    </div>
</div>-->
<!--<div class="form-group col-sm-6 col-md-4 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsExposureAllowed ? '' : 'none'}">
    <div class="form-select form-floating">
        <select name="ctl00$main$Exposure" id="main_Exposure" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.exposure">
            <option selected="selected" value="" disabled>Select Exposure</option>
            <option *ngFor="let exposure of exposureDropdownList" [value]="exposure.value">{{exposure.text}}</option>
        </select>
        <label>Exposure</label>
    </div>
</div>-->
<!--<div class="form-group col-sm-6 col-md-4 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsSafeAtHomeAllowed ? '' : 'none'}">

    <label class="control-label d-block mr-2">Feel safe at home</label>

    <div class="form-inline row">
    <div class="col-auto">
            <div class="custom-control custom-radio">
                <input class="custom-control-input" type="radio" id="FeelSafeYes" (click)="onChangeFeelSafe('True')">
                <label class="custom-control-label cursor-pointer" for="FeelSafeYes">
                    Yes
                </label>
            </div>
    </div>
    <div class="col-auto">
        <div class="custom-control custom-radio">
            <input class="custom-control-input" type="radio" id="FeelSafeNo" (click)="onChangeFeelSafe('False')">
            <label class="custom-control-label cursor-pointer" for="FeelSafeNo">
                No
            </label>
        </div>
    </div>
</div>
</div>-->
<!-- comment start-->
<!--
      </div>
    </fieldset> -->
<!-- comment end-->
<!--<fieldset class="pb-0" [ngStyle]="{'display' : intakeFieldsSetting.isPersonalInfoAllowed ? '' : 'none'}">
    <legend class="lead">Personal Information</legend>
    <div class="row">
        <div class="form-group col-sm-6 col-md-6 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsHighestEduAllowed ? '' : 'none'}">
            <div class="form-select form-floating">
                <select name="ctl00$main$highested" id="main_highested" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.education">
                    <option selected="selected" value="" disabled>Select Highest education</option>
                    <option *ngFor="let education of highestEducationDropdownList" [value]="education.value">{{education.text}}</option>
                </select>
                <label>Education</label>
            </div>
        </div>
        <div class="form-group col-sm-6 col-md-6 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsIndustryAllowed ? '' : 'none'}">
            <div class="form-select form-floating">
                <select name="ctl00$main$industy" id="main_industy" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.industryCode">
                    <option selected="selected" value="" disabled>Select Industry</option>
                    <option *ngFor="let industry of industryDropdownList" [value]="industry.value">{{industry.text}}</option>
                </select>
                <label>Industry</label>
            </div>
        </div>
        <div class="form-group col-6 col-sm-6 col-md-6 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsEffectiveFromAllowed ? '' : 'none'}">
            <div class="form-floating">
                <input type="date" max="{{curDate | date:'yyyy-MM-dd'}}" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.industryStartDate" name="industryStartDate" (change)="onIndustryDateChange()" />
                <label>Effective from</label>
            </div>
        </div>
        <div class="form-group col-6 col-sm-6 col-md-6 col-lg-4" [ngStyle]="{'display' : intakeFieldsSetting.IsEffectiveToAllowed ? '' : 'none'}">
            <div class="form-floating">
                <input type="date" max="{{curDate | date:'yyyy-MM-dd'}}" class="form-control" [(ngModel)]="selected_objPatientSocialHistory.industryEndDate" name="industryEndDate" (change)="onIndustryDateChange()" />
                <label>Effective to</label>
            </div>
        </div>
        <div class="form-group col-sm-12" *ngIf="industoryDateError">
            <p class="err">{{industoryDateError}}</p>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-sm-6">
        </div>
    </div>
</fieldset>-->
<!-- comment start-->
<!--
  </div>
</div> -->
<!-- comment end-->

<div class="row mt-1">
  <div class="col-12">
    <fieldset class="mb-3 pb-0" [ngStyle]="{'display' : intakeFieldsSetting.isSocialHistoryAllowed ? '' : 'none'}">
      <div class="form-group tobaccoDD" id="tobaccostatus" [ngStyle]="{'display' : intakeFieldsSetting.IsTobaccoAllowed ? '' : 'none'}">
        <div class="form-select mb-3 border-bottom">
          <label class="form-label fw-bold">{{'social_history.social_history_tobacco_status'|translate}}</label>
          <select name="ctl00$main$tobaccostatus"  class="form-control border-0"
                  [(ngModel)]="selected_objPatientSocialHistory.tobaccoStatusCode" id="main_tobaccostatus">
            <option selected="selected" value="" disabled>{{'social_history.social_history_tobacco_status'|translate}}</option>
            <option *ngFor="let tobaccoStatus of tobaccoStatusDropdownList"
                    [value]="tobaccoStatus.value">
              {{getTranslatedTextTobaccoStatus(tobaccoStatus.text) | titlecase}}
            </option>
          </select>

        </div>
      </div>

      <div class="form-group  alcoholUsageDiv" id="alcohol" [ngStyle]="{'display' : intakeFieldsSetting.IsAlcoholUsagePerDayAllowed ? '' : 'none'}">

        <div class="form-select mb-3 border-bottom">
          <label class="form-label fw-bold">{{'social_history.social_history_alcohol_usage'|translate}}</label>
          <select name="ctl00$main$alcohol" id="main_alcohol" class="form-control border-0" [(ngModel)]="selected_objPatientSocialHistory.alcoholDay">
            <option selected="selected" value="" disabled>{{'social_history.social_history_alcohol_usage'|translate}}</option>
            <option *ngFor="let alcoholUsageDay of alcoholUsageDayDropdownList" [value]="alcoholUsageDay.value">
              {{getTranslatedTextAlcoholUsage(alcoholUsageDay.text) | titlecase}}
            </option>
          </select>

        </div>
      </div>

      <div class="form-group " id="drug" [ngStyle]="{'display' : intakeFieldsSetting.IsDrugUseAllowed ? '' : 'none'}">
        <div class="form-select mb-3 border-bottom">
          <label class="form-label fw-bold">{{'social_history.social_history_drug_usage'|translate}}</label>
          <select name="ctl00$main$drug" id="main_drug" class="form-control border-0" [(ngModel)]="selected_objPatientSocialHistory.drugUse">
            <option selected="selected" value="" disabled>{{'social_history.social_history_drug_usage'|translate}}</option>
            <option *ngFor="let drugUse of drugUseDropdownList" [value]="drugUse.value">{{getTranslatedTextDrugUsage(drugUse.text) | titlecase}}</option>
          </select>

        </div>
      </div>
    </fieldset>

  </div>
</div>


